import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link } from 'react-router-dom';

import Button from '../../../../global/components/Button/Button';

const CompanyHeaderContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    align-items: center;
    @media (max-width: 600px) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 1.5rem;
        margin-bottom: 1.5rem;
    }
`;

const CompanyHeader = ({
    company,
    jobSections,
    user,
    subRoleCount
}: {
    company: any;
    jobSections: any;
    user: any;
    subRoleCount: number;
}) => (
    <CompanyHeaderContainer>
        <div key={company.id}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}
            >
                <Typography variant={'h2'} color={'secondary'}>
                    {`${company.name} Jobs`}
                </Typography>
                <Link to={`/secure/${user.userID}/statistics/${company.id}`}>
                    <IconButton
                        color={'primary'}
                        disabled={!company.subscription}
                    >
                        <BarChartIcon />
                    </IconButton>
                </Link>
                <Link
                    to={`/edit/${user.userID}/business/${company.id}/companypage`}
                >
                    <IconButton color={'primary'}>
                        <SettingsIcon />
                    </IconButton>
                </Link>
            </div>
            <Typography
                variant='body2'
                style={{
                    display: 'flex',
                    marginTop: '0.875rem'
                }}
            >
                {'You have '}
                <Typography
                    style={{
                        marginLeft: '0.25rem',
                        marginRight: '0.25rem'
                    }}
                    color='primary'
                    variant='body2'
                    component='span'
                >
                    <b>{jobSections.active.jobs.length}</b>
                </Typography>
                {'active job postings.'}
            </Typography>
        </div>
        <div>
            <Button
                to={`/create/${user.userID}/job/${company.id}/intro`}
                variant='contained'
                disabled={
                    !company.subscription ||
                    subRoleCount <= jobSections.active.jobs.length
                }
            >
                {'Post a job'}
            </Button>
        </div>
    </CompanyHeaderContainer>
);

export default CompanyHeader;
